import React from "react";
import ArrowBack from "@mui/icons-material/ArrowBack";
import maintenanceImg from "../../assets/images/maintainence.png";

const UnderMaintenance = () => {
  const handleWebview = () => {
    const mobileData = {
      type: "route",
    };
    window.ReactNativeWebView.postMessage(JSON.stringify(mobileData));
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        background: "#fff",
        boxSizing: "border-box",
      }}
    >
      {/* Header bar with back button */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          padding: "14px 16px",
          borderBottom: "1px solid #f0f0f0",
          background: "#fff",
        }}
      >
        <button
          onClick={handleWebview}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: "4px 8px 4px 0",
            display: "flex",
            alignItems: "center",
            color: "#333",
            fontSize: 22,
            lineHeight: 1,
          }}
          aria-label="Go back"
        >
          <ArrowBack style={{ fontSize: 24, marginRight: 6 }} />
          <span style={{ fontSize: 16 }}>Back</span>
        </button>
      </div>

      {/* Main content */}
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "32px 24px",
        }}
      >
        <img
          src={maintenanceImg}
          alt="Maintenance"
          style={{
            height: "56px",
            width: "56px",
            marginBottom: "24px",
          }}
        />
        <h2
          style={{
            color: "#1a1a1a",
            marginBottom: 12,
            fontSize: 20,
            fontWeight: 700,
            textAlign: "center",
          }}
        >
          Chat is Under Maintenance
        </h2>
        <p
          style={{
            color: "#666",
            fontSize: 15,
            textAlign: "center",
            maxWidth: 300,
            lineHeight: 1.6,
            margin: 0,
          }}
        >
          Our chat support on app is currently unavailable and will be back
          again soon, in the meanwhile please reach out to chat support on
          WhatsApp or Email. Apologies for the inconvenience!
        </p>
      </div>
    </div>
  );
};

export default UnderMaintenance;
